import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';

import { AuthLoaderComponent } from '@f4rm/app-core/components/auth-loader/auth-loader.component';
import { GuardLoadingIndicatorComponent } from '@f4rm/app-core/components/guard-loading-indicator/guard-loading-indicator.component';
import { ModalOutletContainerComponent } from '@f4rm/app-core/components/layout/modal-outlet-container/modal-outlet-container.component';
import { I18nService } from '@f4rm/app-core/services/i18n/i18n.service';
import { LoadingCoordinatorService } from '@f4rm/app-core/services/loading/loading-coordinator.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AuthLoaderComponent, GuardLoadingIndicatorComponent, ModalOutletContainerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private i18nService = inject(I18nService);
  private matIconRegistry = inject(MatIconRegistry);
  private loadingCoordinator = inject(LoadingCoordinatorService);

  protected shouldHideLoader = computed(() => {
    const authInProgress = this.loadingCoordinator.isAuthenticationInProgress();
    const allComplete = this.loadingCoordinator.allOperationsComplete();
    const loginRendered = this.loadingCoordinator.isLoginPageRendered();
    const publicRendered = this.loadingCoordinator.isPublicPageRendered();

    const shouldHide = !authInProgress && (allComplete || loginRendered || publicRendered);

    console.log('[AppComponent] shouldHideLoader:', {
      authInProgress,
      allComplete,
      loginRendered,
      publicRendered,
      result: shouldHide,
    });

    return shouldHide;
  });

  public ngOnInit(): void {
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    this.i18nService.init();
  }
}

